import { EntityData, initialEntityData } from '@new/common/utils/entity-data';
import { Task } from '../../../lib/types';

export interface TasksStateModel {
  items: EntityData<Task[]>;
  selectedIds: string[];
}

export const tasksStateDefaults: TasksStateModel = {
  items: initialEntityData(),
  selectedIds: []
};
